import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';

export const StyledQuickFilterBorder = styled.div`
    border-bottom: ${({ isSelected }) =>
        isSelected ? '3px solid #1010EB' : '3px solid transparent'};
    width: 100%;
    height: 5%;
`;

export const StyledFilterContent = styled.div`
    display: flex;
    height: 95%;
    width: 100%;
    align-items: center;

    ${({ isBatch }) =>
        isBatch &&
        css`
            &:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                width: 0;
                height: 0;
                border-top: ${({ isPending }) =>
                    isPending ? '10px solid  #E89000' : '10px solid #ED002A'};
                border-left: 10px solid transparent;
            }
        `}

    ${media.mobileDevice`
            max-width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
        `}
`;

export const TabGridContianer = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    display: grid;
    grid-auto-rows: 3.25rem;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    box-sizing: border-box;

    ${media.mediumDevice`
    grid-template-columns: repeat(7,1fr);
`}
    ${media.smalDevice`
    grid-template-columns: repeat(7,1fr);
`}
${media.mobileDevice`
    grid-template-columns: repeat(5, 1fr);
    gap: 0px;
`}
`;

export const StyledTabContentContianer = styled.li`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px #00000014;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'};
    border: ${({ isSelected }) =>
        isSelected ? 'none' : '0.5px solid #D7DBDB'};
    opacity: 1;
    height: 100%;
    align-items: center;
    position: relative;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
    ${media.mobileDevice`
    height: 100%;
    box-shadow: none;
    `}
`;

export const TabContent = styled(StyledFilterContent)`
    height: 95%;
    justify-content: flex-start;
    align-items: center;

    ${media.mediumDevice`
        padding: 0 0.3rem;
    `}
    ${media.smalDevice`
        padding: 0 0.2rem;
    `}
    ${media.mobileDevice`
        padding: 0 0.4rem 0 0.1rem;
        align-items: flex-start;
    `}
`;

export const TabSelectedBorder = styled(StyledQuickFilterBorder)``;

export const TabContentFont = styled.p`
    width: ${({ width }) => (width ? width : 'min-content')};
    display: block;
    margin: 0;
    padding-left: 0.3rem;
    text-align: left;
    letter-spacing: 0px;
    color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#4F4F4F')};
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    line-height: 16px;
    opacity: 1;
    ${media.mobileDevice`
        font-size: 10px;
        line-height: 12px;
        text-align: left;
        padding-top: 0.3rem;
        color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#202124')};
    `}
`;
